import { AwardDialogProps } from "@/src/components/banner-dailog/award";

export const awardSectionData_en: AwardDialogProps = {
   cards: [
      {
         img: "/assets/images/award/bp.png"
      },
      {
         img: "/assets/images/award/pt.png"
      },
      {
         img: "/assets/images/award/pd.png"
      },
   ],
};